import { Alert } from '@/global/components/Alert'
import Grid from '@/global/components/ui/Grid'
import { FormField } from 'global/components/Form'
import { useFormContext } from 'react-hook-form'
import { TabelaHorarios } from 'service/api'
import { useCanSubmit } from '../context/CanSubmitContext'

export function ToleranciasForm() {
    const { setValue, watch, formState } = useFormContext<TabelaHorarios>()
    const { setCanSubmit } = useCanSubmit()
    const { errors } = formState

    function onBlur(field: any) {
        return function handleBlur(e: React.FocusEvent<HTMLInputElement>) {
            let value = e.currentTarget.value

            const [hours, minutes] = value.split(':')
            if (hours.length !== 2 || minutes.length !== 2) {
                const paddedHours = (hours ?? '0').padEnd(2, '0'),
                    paddedMinutes = (minutes ?? '0').padEnd(2, '0')
                value = `${paddedHours}:${paddedMinutes}`
            }

            setValue(field, value)
            setCanSubmit(true)
        }
    }

    const defaultProps = {
        size: 'small' as const,
        InputLabelProps: { shrink: true },
        options: {
            time: true,
            timePattern: ['h', 'm'],
        },
        required: true,
        onFocus: () => setCanSubmit(false),
    }

    const [turno, dia] = watch([
        'tolerancias.toleranciaTurno',
        'tolerancias.toleranciaDia',
    ])

    const disabled: Array<'turno' | 'registros' | 'dia'> = (() => {
        if (dia != '00:00') return ['turno', 'registros']
        if (turno != '00:00') return ['dia', 'registros']
        if (turno == '00:00' && dia == '00:00') return ['turno', 'dia']
        return []
    })()

    // Verificar se há erro relacionado a tolerâncias
    const erroTolerancia =
        errors.tolerancias?.toleranciaDia?.message ||
        errors.tolerancias?.toleranciaTurno?.message ||
        errors.tolerancias?.entradaAntes?.message ||
        errors.tolerancias?.entradaDepois?.message ||
        errors.tolerancias?.saidaAntes?.message ||
        errors.tolerancias?.saidaDepois?.message ||
        errors.tolerancias?.root?.message

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.entradaAntes"
                        label="Entrada antes"
                        unHelperText
                        onBlur={onBlur('tolerancias.entradaAntes')}
                        sx={{
                            textDecoration: disabled.includes('registros')
                                ? 'line-through'
                                : 'unset',
                        }}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.entradaDepois"
                        label="Entrada depois"
                        unHelperText
                        onBlur={onBlur('tolerancias.entradaDepois')}
                        sx={{
                            textDecoration: disabled.includes('registros')
                                ? 'line-through'
                                : 'unset',
                        }}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.saidaAntes"
                        label="Saída antes"
                        unHelperText
                        onBlur={onBlur('tolerancias.saidaAntes')}
                        sx={{
                            textDecoration: disabled.includes('registros')
                                ? 'line-through'
                                : 'unset',
                        }}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.saidaDepois"
                        label="Saída depois"
                        unHelperText
                        onBlur={onBlur('tolerancias.saidaDepois')}
                        sx={{
                            textDecoration: disabled.includes('registros')
                                ? 'line-through'
                                : 'unset',
                        }}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.toleranciaTurno"
                        label="Por turno"
                        onBlur={onBlur('tolerancias.toleranciaTurno')}
                        unHelperText
                        sx={{
                            textDecoration: disabled.includes('turno')
                                ? 'line-through'
                                : 'unset',
                        }}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.toleranciaDia"
                        label="Por dia"
                        unHelperText
                        onBlur={onBlur('tolerancias.toleranciaDia')}
                        sx={{
                            textDecoration: disabled.includes('dia')
                                ? 'line-through'
                                : 'unset',
                        }}
                    />
                </Grid>
                {erroTolerancia && (
                    <Grid item xs={12} className="my-2">
                        <Alert severity="error">{erroTolerancia}</Alert>
                    </Grid>
                )}
            </Grid>
        </>
    )
}
